import { render, staticRenderFns } from "./aviator_bets.vue?vue&type=template&id=2dfa3c37&scoped=true&"
import script from "./aviator_bets.vue?vue&type=script&lang=js&"
export * from "./aviator_bets.vue?vue&type=script&lang=js&"
import style0 from "./aviator_bets.vue?vue&type=style&index=0&id=2dfa3c37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa3c37",
  null
  
)

export default component.exports